var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.923,
    height: 15.621,
    viewBox: "0 0 16.923 15.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-qr-scanner",
    "data-name": "Icon ionic-md-qr-scanner",
    transform: "translate(-3.375 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M5.328,6.949a.486.486,0,0,1,.5-.5H8.582V4.5H5.865a2.471,2.471,0,0,0-2.49,2.449V9.707H5.328Z",
    fill: "#176543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M26.375,4.5h-2.75V6.453h2.734a.506.506,0,0,1,.521.5V9.707h1.953V6.949A2.445,2.445,0,0,0,26.375,4.5Z",
    transform: "translate(-8.534)",
    fill: "#176543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M26.879,25.217a.486.486,0,0,1-.5.5H23.625v1.993h2.758a2.471,2.471,0,0,0,2.449-2.49V22.5H26.879Z",
    transform: "translate(-8.534 -7.586)",
    fill: "#176543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M5.824,25.714a.486.486,0,0,1-.5-.5V22.5H3.375v2.717a2.505,2.505,0,0,0,2.49,2.49H8.582V25.714Z",
    transform: "translate(0 -7.586)",
    fill: "#176543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanner);
export default __webpack_public_path__ + "static/media/icon-scanner.aac14e894f3b81014d5d0cb5f26a4bc3.svg";
export { ForwardRef as ReactComponent };